// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".filter___doTe1 {\n  font-size: 12px;\n  padding: 3px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  overflow: hidden;\n}\n.filter___doTe1 label {\n  font-weight: bold;\n  margin-right: 10px;\n}\n", "",{"version":3,"sources":["TranslationFilter.less"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB","file":"TranslationFilter.less","sourcesContent":[".filter {\n  font-size: 12px;\n  padding: 3px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  overflow: hidden;\n}\n.filter label {\n  font-weight: bold;\n  margin-right: 10px;\n}\n"]}]);
// Exports
exports.locals = {
	"filter": "filter___doTe1"
};
module.exports = exports;
